/**
 * @fileoverview gRPC-Web generated client stub for chat
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: chat/chat.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var chatcontext_chatcontext_pb = require('../chatcontext/chatcontext_pb.js')

var artifact_artifact_pb = require('../artifact/artifact_pb.js')

var tichatapi_agent_pb = require('../tichatapi/agent_pb.js')

var common_model_pb = require('../common/model_pb.js')

var playbook_playbook_pb = require('../playbook/playbook_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.chat = require('./chat_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.chat.ChatServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.chat.ChatServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.chat.CreateChatRequest,
 *   !proto.chat.GetChatResponse>}
 */
const methodDescriptor_ChatService_CreateChat = new grpc.web.MethodDescriptor(
  '/chat.ChatService/CreateChat',
  grpc.web.MethodType.UNARY,
  proto.chat.CreateChatRequest,
  proto.chat.GetChatResponse,
  /**
   * @param {!proto.chat.CreateChatRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.chat.GetChatResponse.deserializeBinary
);


/**
 * @param {!proto.chat.CreateChatRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.chat.GetChatResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.chat.GetChatResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.chat.ChatServiceClient.prototype.createChat =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/chat.ChatService/CreateChat',
      request,
      metadata || {},
      methodDescriptor_ChatService_CreateChat,
      callback);
};


/**
 * @param {!proto.chat.CreateChatRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.chat.GetChatResponse>}
 *     Promise that resolves to the response
 */
proto.chat.ChatServicePromiseClient.prototype.createChat =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/chat.ChatService/CreateChat',
      request,
      metadata || {},
      methodDescriptor_ChatService_CreateChat);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.chat.GetChatRequest,
 *   !proto.chat.GetChatResponse>}
 */
const methodDescriptor_ChatService_GetChat = new grpc.web.MethodDescriptor(
  '/chat.ChatService/GetChat',
  grpc.web.MethodType.UNARY,
  proto.chat.GetChatRequest,
  proto.chat.GetChatResponse,
  /**
   * @param {!proto.chat.GetChatRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.chat.GetChatResponse.deserializeBinary
);


/**
 * @param {!proto.chat.GetChatRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.chat.GetChatResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.chat.GetChatResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.chat.ChatServiceClient.prototype.getChat =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/chat.ChatService/GetChat',
      request,
      metadata || {},
      methodDescriptor_ChatService_GetChat,
      callback);
};


/**
 * @param {!proto.chat.GetChatRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.chat.GetChatResponse>}
 *     Promise that resolves to the response
 */
proto.chat.ChatServicePromiseClient.prototype.getChat =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/chat.ChatService/GetChat',
      request,
      metadata || {},
      methodDescriptor_ChatService_GetChat);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.chat.GetOrCreateAppCopilotChatRequest,
 *   !proto.chat.GetChatResponse>}
 */
const methodDescriptor_ChatService_GetOrCreateAppCopilotChat = new grpc.web.MethodDescriptor(
  '/chat.ChatService/GetOrCreateAppCopilotChat',
  grpc.web.MethodType.UNARY,
  proto.chat.GetOrCreateAppCopilotChatRequest,
  proto.chat.GetChatResponse,
  /**
   * @param {!proto.chat.GetOrCreateAppCopilotChatRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.chat.GetChatResponse.deserializeBinary
);


/**
 * @param {!proto.chat.GetOrCreateAppCopilotChatRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.chat.GetChatResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.chat.GetChatResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.chat.ChatServiceClient.prototype.getOrCreateAppCopilotChat =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/chat.ChatService/GetOrCreateAppCopilotChat',
      request,
      metadata || {},
      methodDescriptor_ChatService_GetOrCreateAppCopilotChat,
      callback);
};


/**
 * @param {!proto.chat.GetOrCreateAppCopilotChatRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.chat.GetChatResponse>}
 *     Promise that resolves to the response
 */
proto.chat.ChatServicePromiseClient.prototype.getOrCreateAppCopilotChat =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/chat.ChatService/GetOrCreateAppCopilotChat',
      request,
      metadata || {},
      methodDescriptor_ChatService_GetOrCreateAppCopilotChat);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.chat.ListAppCopilotChatsRequest,
 *   !proto.chat.ListAppCopilotChatsResponse>}
 */
const methodDescriptor_ChatService_ListAppCopilotChats = new grpc.web.MethodDescriptor(
  '/chat.ChatService/ListAppCopilotChats',
  grpc.web.MethodType.UNARY,
  proto.chat.ListAppCopilotChatsRequest,
  proto.chat.ListAppCopilotChatsResponse,
  /**
   * @param {!proto.chat.ListAppCopilotChatsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.chat.ListAppCopilotChatsResponse.deserializeBinary
);


/**
 * @param {!proto.chat.ListAppCopilotChatsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.chat.ListAppCopilotChatsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.chat.ListAppCopilotChatsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.chat.ChatServiceClient.prototype.listAppCopilotChats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/chat.ChatService/ListAppCopilotChats',
      request,
      metadata || {},
      methodDescriptor_ChatService_ListAppCopilotChats,
      callback);
};


/**
 * @param {!proto.chat.ListAppCopilotChatsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.chat.ListAppCopilotChatsResponse>}
 *     Promise that resolves to the response
 */
proto.chat.ChatServicePromiseClient.prototype.listAppCopilotChats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/chat.ChatService/ListAppCopilotChats',
      request,
      metadata || {},
      methodDescriptor_ChatService_ListAppCopilotChats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.chat.CreateAppCopilotChatRequest,
 *   !proto.chat.CreateAppCopilotChatResponse>}
 */
const methodDescriptor_ChatService_CreateAppCopilotChat = new grpc.web.MethodDescriptor(
  '/chat.ChatService/CreateAppCopilotChat',
  grpc.web.MethodType.UNARY,
  proto.chat.CreateAppCopilotChatRequest,
  proto.chat.CreateAppCopilotChatResponse,
  /**
   * @param {!proto.chat.CreateAppCopilotChatRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.chat.CreateAppCopilotChatResponse.deserializeBinary
);


/**
 * @param {!proto.chat.CreateAppCopilotChatRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.chat.CreateAppCopilotChatResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.chat.CreateAppCopilotChatResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.chat.ChatServiceClient.prototype.createAppCopilotChat =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/chat.ChatService/CreateAppCopilotChat',
      request,
      metadata || {},
      methodDescriptor_ChatService_CreateAppCopilotChat,
      callback);
};


/**
 * @param {!proto.chat.CreateAppCopilotChatRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.chat.CreateAppCopilotChatResponse>}
 *     Promise that resolves to the response
 */
proto.chat.ChatServicePromiseClient.prototype.createAppCopilotChat =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/chat.ChatService/CreateAppCopilotChat',
      request,
      metadata || {},
      methodDescriptor_ChatService_CreateAppCopilotChat);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.chat.GetChatMessagesSinceRequest,
 *   !proto.chat.GetChatMessagesSinceResponse>}
 */
const methodDescriptor_ChatService_GetChatMessagesSince = new grpc.web.MethodDescriptor(
  '/chat.ChatService/GetChatMessagesSince',
  grpc.web.MethodType.UNARY,
  proto.chat.GetChatMessagesSinceRequest,
  proto.chat.GetChatMessagesSinceResponse,
  /**
   * @param {!proto.chat.GetChatMessagesSinceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.chat.GetChatMessagesSinceResponse.deserializeBinary
);


/**
 * @param {!proto.chat.GetChatMessagesSinceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.chat.GetChatMessagesSinceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.chat.GetChatMessagesSinceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.chat.ChatServiceClient.prototype.getChatMessagesSince =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/chat.ChatService/GetChatMessagesSince',
      request,
      metadata || {},
      methodDescriptor_ChatService_GetChatMessagesSince,
      callback);
};


/**
 * @param {!proto.chat.GetChatMessagesSinceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.chat.GetChatMessagesSinceResponse>}
 *     Promise that resolves to the response
 */
proto.chat.ChatServicePromiseClient.prototype.getChatMessagesSince =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/chat.ChatService/GetChatMessagesSince',
      request,
      metadata || {},
      methodDescriptor_ChatService_GetChatMessagesSince);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.chat.ListChatsResponse>}
 */
const methodDescriptor_ChatService_ListChats = new grpc.web.MethodDescriptor(
  '/chat.ChatService/ListChats',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.chat.ListChatsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.chat.ListChatsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.chat.ListChatsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.chat.ListChatsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.chat.ChatServiceClient.prototype.listChats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/chat.ChatService/ListChats',
      request,
      metadata || {},
      methodDescriptor_ChatService_ListChats,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.chat.ListChatsResponse>}
 *     Promise that resolves to the response
 */
proto.chat.ChatServicePromiseClient.prototype.listChats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/chat.ChatService/ListChats',
      request,
      metadata || {},
      methodDescriptor_ChatService_ListChats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.chat.ListChatsForPlaybookRequest,
 *   !proto.chat.ListChatsForPlaybookResponse>}
 */
const methodDescriptor_ChatService_ListChatsForPlaybook = new grpc.web.MethodDescriptor(
  '/chat.ChatService/ListChatsForPlaybook',
  grpc.web.MethodType.UNARY,
  proto.chat.ListChatsForPlaybookRequest,
  proto.chat.ListChatsForPlaybookResponse,
  /**
   * @param {!proto.chat.ListChatsForPlaybookRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.chat.ListChatsForPlaybookResponse.deserializeBinary
);


/**
 * @param {!proto.chat.ListChatsForPlaybookRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.chat.ListChatsForPlaybookResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.chat.ListChatsForPlaybookResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.chat.ChatServiceClient.prototype.listChatsForPlaybook =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/chat.ChatService/ListChatsForPlaybook',
      request,
      metadata || {},
      methodDescriptor_ChatService_ListChatsForPlaybook,
      callback);
};


/**
 * @param {!proto.chat.ListChatsForPlaybookRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.chat.ListChatsForPlaybookResponse>}
 *     Promise that resolves to the response
 */
proto.chat.ChatServicePromiseClient.prototype.listChatsForPlaybook =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/chat.ChatService/ListChatsForPlaybook',
      request,
      metadata || {},
      methodDescriptor_ChatService_ListChatsForPlaybook);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.chat.UpdateChatRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ChatService_UpdateChat = new grpc.web.MethodDescriptor(
  '/chat.ChatService/UpdateChat',
  grpc.web.MethodType.UNARY,
  proto.chat.UpdateChatRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.chat.UpdateChatRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.chat.UpdateChatRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.chat.ChatServiceClient.prototype.updateChat =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/chat.ChatService/UpdateChat',
      request,
      metadata || {},
      methodDescriptor_ChatService_UpdateChat,
      callback);
};


/**
 * @param {!proto.chat.UpdateChatRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.chat.ChatServicePromiseClient.prototype.updateChat =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/chat.ChatService/UpdateChat',
      request,
      metadata || {},
      methodDescriptor_ChatService_UpdateChat);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.chat.SendChatMessageRequest,
 *   !proto.chat.SendChatMessageResponse>}
 */
const methodDescriptor_ChatService_SendChatMessage = new grpc.web.MethodDescriptor(
  '/chat.ChatService/SendChatMessage',
  grpc.web.MethodType.UNARY,
  proto.chat.SendChatMessageRequest,
  proto.chat.SendChatMessageResponse,
  /**
   * @param {!proto.chat.SendChatMessageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.chat.SendChatMessageResponse.deserializeBinary
);


/**
 * @param {!proto.chat.SendChatMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.chat.SendChatMessageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.chat.SendChatMessageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.chat.ChatServiceClient.prototype.sendChatMessage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/chat.ChatService/SendChatMessage',
      request,
      metadata || {},
      methodDescriptor_ChatService_SendChatMessage,
      callback);
};


/**
 * @param {!proto.chat.SendChatMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.chat.SendChatMessageResponse>}
 *     Promise that resolves to the response
 */
proto.chat.ChatServicePromiseClient.prototype.sendChatMessage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/chat.ChatService/SendChatMessage',
      request,
      metadata || {},
      methodDescriptor_ChatService_SendChatMessage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.chat.ReactToAnswerRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ChatService_ReactToAnswer = new grpc.web.MethodDescriptor(
  '/chat.ChatService/ReactToAnswer',
  grpc.web.MethodType.UNARY,
  proto.chat.ReactToAnswerRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.chat.ReactToAnswerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.chat.ReactToAnswerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.chat.ChatServiceClient.prototype.reactToAnswer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/chat.ChatService/ReactToAnswer',
      request,
      metadata || {},
      methodDescriptor_ChatService_ReactToAnswer,
      callback);
};


/**
 * @param {!proto.chat.ReactToAnswerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.chat.ChatServicePromiseClient.prototype.reactToAnswer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/chat.ChatService/ReactToAnswer',
      request,
      metadata || {},
      methodDescriptor_ChatService_ReactToAnswer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.chat.DeleteReactionToAnswerRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ChatService_DeleteReactionToAnswer = new grpc.web.MethodDescriptor(
  '/chat.ChatService/DeleteReactionToAnswer',
  grpc.web.MethodType.UNARY,
  proto.chat.DeleteReactionToAnswerRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.chat.DeleteReactionToAnswerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.chat.DeleteReactionToAnswerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.chat.ChatServiceClient.prototype.deleteReactionToAnswer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/chat.ChatService/DeleteReactionToAnswer',
      request,
      metadata || {},
      methodDescriptor_ChatService_DeleteReactionToAnswer,
      callback);
};


/**
 * @param {!proto.chat.DeleteReactionToAnswerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.chat.ChatServicePromiseClient.prototype.deleteReactionToAnswer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/chat.ChatService/DeleteReactionToAnswer',
      request,
      metadata || {},
      methodDescriptor_ChatService_DeleteReactionToAnswer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.chat.DeleteChatRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ChatService_DeleteChat = new grpc.web.MethodDescriptor(
  '/chat.ChatService/DeleteChat',
  grpc.web.MethodType.UNARY,
  proto.chat.DeleteChatRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.chat.DeleteChatRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.chat.DeleteChatRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.chat.ChatServiceClient.prototype.deleteChat =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/chat.ChatService/DeleteChat',
      request,
      metadata || {},
      methodDescriptor_ChatService_DeleteChat,
      callback);
};


/**
 * @param {!proto.chat.DeleteChatRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.chat.ChatServicePromiseClient.prototype.deleteChat =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/chat.ChatService/DeleteChat',
      request,
      metadata || {},
      methodDescriptor_ChatService_DeleteChat);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.chat.StopChatRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ChatService_StopChat = new grpc.web.MethodDescriptor(
  '/chat.ChatService/StopChat',
  grpc.web.MethodType.UNARY,
  proto.chat.StopChatRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.chat.StopChatRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.chat.StopChatRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.chat.ChatServiceClient.prototype.stopChat =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/chat.ChatService/StopChat',
      request,
      metadata || {},
      methodDescriptor_ChatService_StopChat,
      callback);
};


/**
 * @param {!proto.chat.StopChatRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.chat.ChatServicePromiseClient.prototype.stopChat =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/chat.ChatService/StopChat',
      request,
      metadata || {},
      methodDescriptor_ChatService_StopChat);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.chat.SearchChatRequest,
 *   !proto.chat.SearchChatResponse>}
 */
const methodDescriptor_ChatService_SearchChats = new grpc.web.MethodDescriptor(
  '/chat.ChatService/SearchChats',
  grpc.web.MethodType.UNARY,
  proto.chat.SearchChatRequest,
  proto.chat.SearchChatResponse,
  /**
   * @param {!proto.chat.SearchChatRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.chat.SearchChatResponse.deserializeBinary
);


/**
 * @param {!proto.chat.SearchChatRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.chat.SearchChatResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.chat.SearchChatResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.chat.ChatServiceClient.prototype.searchChats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/chat.ChatService/SearchChats',
      request,
      metadata || {},
      methodDescriptor_ChatService_SearchChats,
      callback);
};


/**
 * @param {!proto.chat.SearchChatRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.chat.SearchChatResponse>}
 *     Promise that resolves to the response
 */
proto.chat.ChatServicePromiseClient.prototype.searchChats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/chat.ChatService/SearchChats',
      request,
      metadata || {},
      methodDescriptor_ChatService_SearchChats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.chat.ListTimelineEventsRequest,
 *   !proto.chat.ListTimelineEventsResponse>}
 */
const methodDescriptor_ChatService_ListTimelineEvents = new grpc.web.MethodDescriptor(
  '/chat.ChatService/ListTimelineEvents',
  grpc.web.MethodType.UNARY,
  proto.chat.ListTimelineEventsRequest,
  proto.chat.ListTimelineEventsResponse,
  /**
   * @param {!proto.chat.ListTimelineEventsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.chat.ListTimelineEventsResponse.deserializeBinary
);


/**
 * @param {!proto.chat.ListTimelineEventsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.chat.ListTimelineEventsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.chat.ListTimelineEventsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.chat.ChatServiceClient.prototype.listTimelineEvents =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/chat.ChatService/ListTimelineEvents',
      request,
      metadata || {},
      methodDescriptor_ChatService_ListTimelineEvents,
      callback);
};


/**
 * @param {!proto.chat.ListTimelineEventsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.chat.ListTimelineEventsResponse>}
 *     Promise that resolves to the response
 */
proto.chat.ChatServicePromiseClient.prototype.listTimelineEvents =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/chat.ChatService/ListTimelineEvents',
      request,
      metadata || {},
      methodDescriptor_ChatService_ListTimelineEvents);
};


module.exports = proto.chat;

